const Parsereval = require('expr-eval').Parser;

/* used for table show-summary summary-method */
function getSummaries (param) {
    const { columns, data } = param;
    const sums = [];
    columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = 'Total Sum';
            return;
        }
        const values = data.map(item => Number(item[column.property]));
        /* son kolon hesaplanabilir varsayimi */
        if (index == (columns.length - 1) && !values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
            }, 0);
        }
    });
    return sums;
}

function calculatedQuestions(question, formQuestions) {
    if (!question.calc_method) return null;
    // let self = this;
    const tokens = question.calc_method;

    const initialValue = '';
    const sumWithInitial = tokens.reduce((previousValue, currentValue) => {
        let val;
        if (currentValue.type === 'NUM') {
            val = formQuestions.find(
                (element) =>
                    element.id == currentValue.value /*&&
                    element.form_ques_data_group_id == questio.form_ques_data_group_id*/
            );
            return `${previousValue}${val?.data?.return_value || 0.0}`;
        }
        if (currentValue.type === 'OP') {
            return `${previousValue}${currentValue.value}`;
        }
        if (currentValue.type === 'CONS') {
            return `${previousValue}${currentValue.value}`;
        }
        if (currentValue.type === 'SUM') {
            val = 0;
            val += formQuestions
                .filter((element) => element.id == currentValue.value)
                .reduce(
                    (previousValue2, currentValue2) =>
                        parseFloat(previousValue2) + parseFloat(currentValue2?.data?.return_value || 0.0),
                    0
                );
            return `${previousValue}${val || 0.0}`;
        }
        return `${previousValue}${currentValue.type}`;
    }, initialValue);

    const parser = new Parsereval();
    const expr = parser.parse(sumWithInitial);
    const res = expr.evaluate();
    question.data.return_value = `${res}`;
    return res;
}


// function calculatedQuestions (question, sections) {
//     if (!question.calc_method) return;
//     var tokens = question.calc_method;
//     const initialValue = '';
//     var sumWithInitial = tokens.reduce(
//         (previousValue, currentValue) => {
//             if (currentValue.type === 'NUM') {
//                 var val;
//                 for (var i = 0; i < sections.length; i++) {
//                     var section = sections[i];
//                     val = section.questions.find(element => element.id == currentValue.value);
//                     if (val) {
//                         break;
//                     }
//                 }
//                 return previousValue + '' + (val?.data?.return_value || 0.0);
//             } else if (currentValue.type === 'OP') {
//                 return previousValue + '' + currentValue.value;
//             } else if (currentValue.type === 'CONS') {
//                 return previousValue + '' + currentValue.value;
//             } else if (currentValue.type === 'SUM') {
//                 var val = 0;
//                 for (var i = 0; i < sections.length; i++) {
//                     var section = sections[i];
//                     val += section.questions.filter(element => element.id == currentValue.value).reduce(
//                         (previousValue, currentValue) => parseFloat(previousValue) + parseFloat((currentValue?.data?.return_value || 0)),
//                         0
//                     );
//                 }
//                 return previousValue + '' + (val || 0.0);
//             } else {
//                 return previousValue + '' + currentValue.type;
//             }
//         },
//         initialValue
//     );
//     var parser = new Parsereval();
//     var expr = parser.parse(sumWithInitial);
//     var res = expr.evaluate(); // 7
//     question.data.return_value = '' + res;
//     return res;
// }

exports.getSummaries = getSummaries
exports.calculatedQuestions = calculatedQuestions